import clsx from 'clsx';
import React from 'react';
import styles from './HdDeterminateProgressBar.module.scss';

interface HdDeterminateProgressBarProps {
  value?: number;
  maxValue?: number;
  color?: string;
  className?: string;
  showPercentage?: boolean;
}

export function HdDeterminateProgressBar({
  value,
  maxValue,
  color,
  className = '',
  showPercentage = false
}: HdDeterminateProgressBarProps) {
  let percentage: number;

  if (!maxValue) {
    percentage = 100;
  } else if (!value) {
    percentage = 0;
  } else {
    percentage = Math.round((value / maxValue) * 100);
  }

  return (
    <div className={className}>
      <div className='d-flex align-items-center'>
        <div className={styles.progressBarWrapper}>
          <div
            data-id='determinate-progress-bar'
            className={clsx(styles.progressPercentage, styles.normal, styles[color])}
            style={{ width: `${percentage}%` }}
          />
        </div>

        {showPercentage ? <div data-id='determinate-progress-percent' className='text-body-4 ml-2'>{percentage}%</div> : null}
      </div>
    </div>
  );
}
